export default {
  data: [],
  aggregatedData: [],
  headers: [],
  interResult: [],
  unionResult: [],
  querys: [],
  repIds: [],
  weightCache: {},
};
